import React from "react";
import FindDealerStore from "../../stores/FindDealerStore";
import { observer, inject } from "mobx-react";
import ReactCSSTransitionReplace from "react-css-transition-replace";
import { OpeningHours, Rating } from "./";
import classNames from "classnames";

interface Props {
  findDealerStore?: FindDealerStore;
  rating: number;
}

const DealerInfo = (props: Props) => {
  const { findDealerStore, rating } = props;
  const { selectedDealer, suburb, departmentsFilter } = findDealerStore;
  const { name, dealerDetails, id, distance, state } =
    !!selectedDealer && selectedDealer;

  let department;

  if (departmentsFilter === "all") {
    department = dealerDetails;
  } else {
    department =
      selectedDealer &&
      dealerDetails.filter((item) => {
        return item.departmentName === departmentsFilter;
      });
  }

  const { address, postCode, phone, departmentName, url } =
    !!selectedDealer && department.length > 0 && department[0];
  const dealerSuburb =
    !!selectedDealer && department.length > 0 && department[0].suburb;
  const dealerPostCode =
    !!selectedDealer && department.length > 0 && department[0].postCode;
  const directionsUrl =
    suburb &&
    `https://www.google.com/maps/dir/Current+Location/${address}+${postCode}`;
  const clearPhone = phone && phone.replace(/[- )(]/g, "");

  const hasSingleMotorSportDepartment = () => {
    const motorSportDepartment =
      selectedDealer &&
      selectedDealer.dealerDetails.filter(
        (department) => department.departmentName === "Motorsport Parts"
      );
    if (selectedDealer.dealerDetails.length === 1 && motorSportDepartment[0]) {
      return true;
    } else {
      return false;
    }
  };

  const mainCtaText = classNames({
    "View full details": selectedDealer && !hasSingleMotorSportDepartment(),
    "Visit website": selectedDealer && hasSingleMotorSportDepartment(),
  });

  return (
    <ReactCSSTransitionReplace
      transitionName="slide-in"
      transitionEnterTimeout={400}
      transitionLeaveTimeout={300}
    >
      <div key={id}>
        {selectedDealer && (
          <div className="dealer-info">
            <p className="dealer-name">{name}</p>
            <p className="dealer-phone">
              <a href={`tel:${clearPhone}`}>{phone}</a>
            </p>
            <p className="dealer-address">
              {address}
              <br />
              {selectedDealer &&
                department.length > 0 &&
                `${dealerSuburb} ${state} ${dealerPostCode}`}
              <br />
              {directionsUrl && suburb && !selectedDealer.isMobileDealer && (
                <span className="dealer-direction">
                  <a href={directionsUrl} target="_blank">
                    Get Directions
                  </a>
                </span>
              )}
            </p>
            {department.length > 0 && (
              <OpeningHours dealerDetails={department[0]} collapsible={true} />
            )}
            {!!rating && (
              <p className="dealer-reviews">
                Google reviews
                <br />
                <Rating isLarge={false} ratingValue={rating} />
              </p>
            )}
            {selectedDealer && (
              <p className="dealer-cta">
                {hasSingleMotorSportDepartment() ? (
                  <a href={`${url}`} target="_blank" className="btn primary">
                    {mainCtaText}
                  </a>
                ) : (
                  <a
                    href={`/dealers/${selectedDealer.uniqueName}`}
                    target="_self"
                    className="btn primary"
                  >
                    {mainCtaText}
                  </a>
                )}
              </p>
            )}
          </div>
        )}
      </div>
    </ReactCSSTransitionReplace>
  );
};

export default inject("findDealerStore")(observer(DealerInfo));
